// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textOverflow[data-v-7a179422] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.multiLine[data-v-7a179422] {\n  display: -webkit-box;\n  white-space: unset;\n  /*! autoprefixer: off */\n  -webkit-box-orient: vertical;\n}\n", ""]);
// Exports
module.exports = exports;
